import React from 'react';
import './HeroSection.css';

const HeroSection = () => {

    const scrollToNewsletter = () => {
        const newsletterElement = document.getElementById('newsletter-signup');
        if (newsletterElement) {
            newsletterElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="hero-section">
            <img className="hero-image" src="/Images/Background.png" alt="Background" />
            <div className="overlay"></div>
            <div className="hero-content">
                <div className="title">
                    <div className="main-title">Foot health,</div>
                    <div className="subtitle">In your pocket.</div>
                </div>
                <div className="description">
                    To create a future where every child can <br /> <span className="highlight">walk</span>, <span className="highlight">run</span>, and <span className="highlight">play</span> without discomfort.
                </div>
                
                {/* Updated CTA Section */}
                <div className="cta">
                    <button className="cta-button" onClick={scrollToNewsletter}>
                        Sign Up for 40% off
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
